import { tokens } from '@arvoreeducacao/bonsai-ds'
import { Player } from '@lottiefiles/react-lottie-player'
import styled from 'styled-components'
import { Cdn } from 'utils/assets'

const leaves = Cdn.getLottieAnimation('login/leaves_login.json')
const logoArvore = Cdn.getImageUrl('logos/novo-logo-arvore.svg')

export const ContainerDesktop = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: linear-gradient(
    186.06deg,
    rgba(232, 246, 218, 0) -40.97%,
    rgba(229, 247, 211, 0.402) 34.92%,
    rgba(149, 242, 232, 0.6) 95.2%
  );

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: column;
  }

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
`

export const ContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
`

export const WelcomeText = styled.strong`
  display: none;
  color: ${tokens.colors.dark6};
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.xlarge};
  text-align: center;
  margin: 80px;

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    display: block;
  }
`

export const ArvoreImg = styled.img.attrs({
  src: logoArvore,
  alt: 'Logo árvore'
})`
  width: 204px;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 134px;
  }

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    width: 88px;
  }
`

export const LeavesContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`

export const LeavesImg = styled(Player).attrs({
  src: leaves,
  autoplay: true,
  loop: true
})`
  width: 700px;

  @media (max-width: ${tokens.breakpoints.desktopLarge}px) {
    width: 560px;
  }

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 420px;
  }

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    width: 278px;
  }
`

export const ButtonNotMe = styled.button`
  background: none;
  border: 0;
  padding: 0;
  font-family: inherit;
  line-height: inherit;
  display: none;
  position: absolute;
  top: 28px;
  left: 32px;

  color: ${tokens.colors.dark5};
  text-decoration: underline;
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  text-align: center;
  cursor: pointer;

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    display: block;
  }
`
